module.exports = "./img/c9bc5de33e3b86cabc49fdb38d95465d.jpg";